import FrontendFaq from './faq';

export default class FrontendFaqDesktop extends FrontendFaq {
}
